import * as React from "react";

import { Table } from "semantic-ui-react";

import { ClinicianModel } from "./models";

const ClinicianDetails: React.FunctionComponent<ClinicianModel> = (props) => {
    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>
                        Certificate Created By
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                { props.name?.trim() &&
                    <Table.Row>
                        <Table.Cell>
                            <strong>{props.name}</strong>
                        </Table.Cell>
                    </Table.Row>
                }
                { props.profession?.trim() &&
                    <Table.Row>
                        <Table.Cell>
                            {props.profession}
                        </Table.Cell>
                    </Table.Row>
                }
                { props.qualification?.trim() &&
                    <Table.Row>
                        <Table.Cell>
                            {props.qualification}
                        </Table.Cell>
                    </Table.Row>
                }
            </Table.Body>
        </Table>
    );
};

export { ClinicianDetails };
